// extracted by mini-css-extract-plugin
export default {"arrow":"_1wxTl","mobile":"_1Q585"};